/* Sunkissed custom: "Make it a set" on the product page (CRO build, Sep 2026; panel Oct 7 2026).
   On a Top or Bottom product page, a compact sand panel under the size row offers the matching
   piece in the same style + colourway: checkbox, thumbnail, "$70 with set · set total $149",
   and size chips for the matching piece (shown only when ticked, nothing preselected unless the
   shopper already picked a size for this piece). Ticked: one button adds both pieces.
   Match source: predictive search (same style family + colour), then recommendations.
   Nothing renders (theme stays untouched) when no match is found.
   Set price = the two pieces minus SET_SAVING_CENTS ($158 -> $149); the saving is applied in the
   bag by the "Complete the set" automatic discount.
   Oct 8 2026: this piece's own size starts unpicked (sk-size-gate.js); the button waits for it first.
   Oct 12 2026: prices show in the shopper's own currency (window.SK_INTL, snippets/sk-intl.liquid) and
   the $9 saving is converted at the live rate, so it matches what the discount takes off in the bag.
   Set prices outside USD are rounded to whole units. */
(function () {
  'use strict';
  var SET_SAVING_CENTS = 900;    // $9 (USD) set saving: must equal the "Complete the set" automatic discount
  var SET_DEFAULT_ON = false;    // set starts off; shopper opts in with the checkbox
  var page = document.querySelector('.product__page');
  if (!page) return;

  function pieceOf(t) { if (/\bone[- ]?piece\b/i.test(t) || /\bset\b/i.test(t)) return null; if (/\bbottom\b/i.test(t)) return 'bottom'; if (/\btop\b/i.test(t)) return 'top'; return null; }
  function colorOf(t) { var i = t.lastIndexOf(' - '); return i > -1 ? t.slice(i + 3).trim() : null; }
  function fam(t) { if (/sporty/i.test(t)) return 'sporty'; if (/triangle/i.test(t)) return 'triangle'; if (/bandeau|strapless|cheeky|\bbas\b/i.test(t)) return 'bandeau'; return ''; }
  var WORDS = { triangle: { top: 'Triangle Top', bottom: 'Triangle Bottom', set: 'Triangle Set' }, sporty: { top: 'Sporty Top', bottom: 'Sporty Bottom', set: 'Sporty Set' }, bandeau: { top: 'Bandeau Strapless Top', bottom: 'Bas Cheeky Bottom', set: 'Strapless Cheeky Set' } };
  function money(c) { if (window.SK_INTL) return SK_INTL.money(c); var v = c / 100; return '$' + (Math.round(v) === v ? v : v.toFixed(2)); }
  function setMoney(c) { return window.SK_INTL ? SK_INTL.moneyRound(c) : money(c); }
  function saving() { var s = Math.max(SET_SAVING_CENTS, 0); return window.SK_INTL ? SK_INTL.conv(s) : s; }
  function fetchJson(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgUrl(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  function currentTitle() { var t = page.querySelector('.product__title [data-zoom-caption]') || page.querySelector('.product__title'); return t ? t.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function currentHandle() { var m = location.pathname.match(/\/products\/([a-z0-9-]+)/i); return m ? m[1] : null; }
  function productId() { var el = page.querySelector('form[action*="/cart/add"] [name="product-id"], [data-product-id]'); return el ? (el.value || el.getAttribute('data-product-id')) : null; }
  function sizeIdx(prod) { var idx = -1; (prod.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (/size/i.test(n || '')) idx = i; }); return idx; }

  function sizeWrapper() {
    var w = page.querySelector('.selector-wrapper--size');
    if (w) return w;
    var legends = page.querySelectorAll('.radio__legend');
    for (var i = 0; i < legends.length; i++) { var n = legends[i].querySelector('.radio__legend__option-name'); if (n && /size/i.test(n.textContent)) return legends[i].closest('.selector-wrapper') || legends[i].closest('fieldset'); }
    return null;
  }
  function sizeRadios() { var w = sizeWrapper(); return w ? Array.prototype.slice.call(w.querySelectorAll('input[type="radio"]')) : []; }
  function checkedSize() { var r = sizeRadios().filter(function (x) { return x.checked; })[0]; return r ? r.value : null; }

  function search(words, color) { return fetchJson('/search/suggest.json?q=' + encodeURIComponent(words + (color ? ' ' + color : '')) + '&resources[type]=product&resources[limit]=10').then(function (r) { return (r && r.resources && r.resources.results && r.resources.results.products) || []; }); }
  function sameLook(t, color, f) { return (!color || (colorOf(t) || '').toLowerCase() === color.toLowerCase()) && (!f || fam(t) === f); }

  function findMatch(title, pid, handle) {
    var mine = pieceOf(title);
    var want = mine === 'top' ? 'bottom' : mine === 'bottom' ? 'top' : null;
    if (!want) return Promise.resolve(null);
    var color = colorOf(title), f = fam(title);
    var srcs = [
      search((WORDS[f] && WORDS[f][want]) || want, color),
      pid ? fetchJson('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=complementary') : Promise.resolve(null)
    ];
    return Promise.all(srcs).then(function (r) {
      var all = (r[0] || []).concat((r[1] && r[1].products) || []);
      var pick = null;
      all.forEach(function (p) {
        var t = p.title || ''; var h = p.handle || ((p.url || '').match(/\/products\/([a-z0-9-]+)/i) || [])[1];
        if (pick || !h || h === handle) return;
        if (pieceOf(t) !== want || !sameLook(t, color, f)) return;
        pick = h;
      });
      return pick ? fetchJson('/products/' + pick + '.js') : null;
    });
  }
  function findSet(title) {
    var color = colorOf(title), f = fam(title);
    return search((WORDS[f] && WORDS[f].set) || 'Set', color).then(function (list) {
      return list.filter(function (p) { var t = p.title || ''; return /\sSet\b/.test(t) && sameLook(t, color, f); })[0] || null;
    });
  }

  var state = { main: null, match: null, on: SET_DEFAULT_ON, el: null, row: null, matchVariantId: null, matchTouched: false, mainTouched: false, passThrough: false };

  function mainVariant() {
    var input = page.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = input ? parseInt(input.value, 10) : null;
    var vs = state.main && state.main.variants || [];
    return vs.filter(function (v) { return v.id === id; })[0] || vs.filter(function (v) { return v.available; })[0] || null;
  }
  function matchVariant() {
    if (!state.match) return null;
    return (state.match.variants || []).filter(function (v) { return v.id === state.matchVariantId; })[0] || null;
  }
  function labelOf(prod, v) { var idx = sizeIdx(prod); return idx > -1 ? v['option' + (idx + 1)] : v.title; }
  function sizeSquares(prod, selectedId, attr) {
    return (prod.variants || []).map(function (v) {
      var label = labelOf(prod, v);
      return '<button type="button" class="sk-sq' + (v.id === selectedId ? ' is-selected' : '') + '" ' + attr + '="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-pressed="' + (v.id === selectedId ? 'true' : 'false') + '">' + esc(label) + '</button>';
    }).join('');
  }
  // Same size as this piece, only when that size is in stock (no fallback to another size)
  function sameSizeMatch(label) {
    if (!label) return null;
    return (state.match.variants || []).filter(function (v) { return v.available && labelOf(state.match, v) === label; })[0] || null;
  }
  function matchPiece() { return state.match ? pieceOf(state.match.title) : null; }
  // Set price = the two real prices minus the set saving (no invented compare-at prices)
  function setPricing(mv, xv) { var full = mv.price + xv.price, s = saving(); return { full: full, price: full - s, each: xv.price - s }; }
  function refMatch() { return matchVariant() || (state.match.variants || []).filter(function (v) { return v.available; })[0] || state.match.variants[0]; }

  function render() {
    var theirs = matchPiece(), Theirs = cap(theirs);
    var matchImg = imgUrl((state.match.featured_image || (state.match.images && state.match.images[0]) || ''), 160);
    var w = sizeWrapper(); if (!w) return;

    var row = document.createElement('div');
    row.className = 'sk-mk' + (state.on ? ' is-on' : ''); row.setAttribute('data-sk-match', '');
    row.innerHTML =
      '<button type="button" class="sk-mk__head" role="checkbox" aria-checked="' + (state.on ? 'true' : 'false') + '" data-sk-mk-toggle>' +
        '<span class="sk-mk__box" aria-hidden="true"></span>' +
        (matchImg ? '<img class="sk-mk__img" src="' + matchImg + '" alt="" loading="lazy">' : '') +
        '<span class="sk-mk__txt"><span class="sk-mk__t">Make it a set: add the ' + theirs + '</span><span class="sk-mk__s" data-sk-mk-sub></span></span>' +
      '</button>' +
      '<div class="sk-mk__sizes">' +
        '<div class="sk-mk__lab">' + Theirs + ' size<b data-sk-match-label></b><small data-sk-mk-hint>Pick your size</small></div>' +
        '<div class="sk-mk__sq" data-sk-match-sizes>' + sizeSquares(state.match, state.matchVariantId, 'data-sk-match-size') + '</div>' +
      '</div>';
    var ph = page.querySelector('[data-sk-pair-placeholder]');
    if (ph) ph.parentNode.replaceChild(row, ph); else w.parentNode.insertBefore(row, w.nextSibling);

    state.el = row; state.row = row;
    page.classList.add('sk-pair-active');
    page.classList.toggle('sk-set-on', state.on);

    // Capture-phase so the theme's own form handlers never swallow the tap
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-sk-mk-toggle]'); if (!t) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      setMode(!state.on);
    }, true);
    document.addEventListener('click', function (e) {
      var sq = e.target && e.target.closest && e.target.closest('[data-sk-match-size]'); if (!sq || sq.disabled) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      state.matchTouched = true;
      state.matchVariantId = parseInt(sq.getAttribute('data-sk-match-size'), 10);
      paintMatchSizes(); refreshButton();
      document.dispatchEvent(new CustomEvent('sk:set:change', { bubbles: true, detail: { on: state.on } }));
    }, true);
    document.addEventListener('change', function (e) { var w2 = sizeWrapper(); if (w2 && e.target && w2.contains(e.target)) state.mainTouched = true; }, true);
    document.addEventListener('theme:variant:change', function () {
      // follow this piece's size unless the shopper already chose the other size by hand
      if (state.on && state.mainTouched && !state.matchTouched) { var v = sameSizeMatch(checkedSize()); state.matchVariantId = v ? v.id : null; paintMatchSizes(); }
      setTimeout(refreshButton, 40);
    });
    paintMatchSizes();
    refreshButton();
    findSet(state.main.title).then(function (s) {
      if (!s || !s.handle) return;
      var a = document.createElement('a'); a.className = 'sk-fullset'; a.href = '/products/' + s.handle; a.textContent = 'See the full set →';
      var blk = page.querySelector('.product__block--buttons');
      if (blk) blk.parentNode.insertBefore(a, blk.nextSibling); else row.parentNode.insertBefore(a, row.nextSibling);
    });
    document.dispatchEvent(new CustomEvent('sk:set:ready', { bubbles: true }));
  }

  function setMode(on) {
    state.on = on;
    if (on && !state.matchVariantId && state.mainTouched) { var v = sameSizeMatch(checkedSize()); if (v) state.matchVariantId = v.id; }
    page.classList.toggle('sk-set-on', on);
    if (state.row) {
      state.row.classList.toggle('is-on', on);
      var t = state.row.querySelector('[data-sk-mk-toggle]'); if (t) t.setAttribute('aria-checked', on ? 'true' : 'false');
    }
    paintMatchSizes();
    refreshButton();
    document.dispatchEvent(new CustomEvent('sk:set:change', { bubbles: true, detail: { on: on } }));
  }
  function paintMatchSizes() {
    if (!state.row) return;
    Array.prototype.forEach.call(state.row.querySelectorAll('[data-sk-match-size]'), function (b) {
      var sel = parseInt(b.getAttribute('data-sk-match-size'), 10) === state.matchVariantId;
      b.classList.toggle('is-selected', sel); b.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    var xv = matchVariant();
    var lab = state.row.querySelector('[data-sk-match-label]'); if (lab) lab.textContent = xv ? ' · ' + labelOf(state.match, xv) : '';
    var hint = state.row.querySelector('[data-sk-mk-hint]'); if (hint) hint.hidden = !!xv;
  }
  function paintSub() {
    var sub = state.row && state.row.querySelector('[data-sk-mk-sub]'); var mv = mainVariant(); if (!sub || !mv) return;
    var sp = setPricing(mv, refMatch());
    sub.textContent = setMoney(sp.each) + ' with set · set total ' + setMoney(sp.price);
  }

  // Sunkissed (Oct 6): per-variant preorder flag from the theme's variant metafields JSON
  function isPre(v) { var m = document.querySelector('[data-variant-metafields]'); if (!v || !m) return false; try { return JSON.parse(m.textContent).some(function (x) { return Number(x.variant_id) === v.id && x.preorder === 'true'; }); } catch (e) { return false; } }
  function addButton() { return page.querySelector('form[action*="/cart/add"] [data-add-to-cart]'); }
  function waiting() { return !!(state.el && state.on && !matchVariant()); }

  function refreshButton() {
    paintSub();
    var btn = addButton(); if (!btn) return;
    var txt = btn.querySelector('[data-add-to-cart-text]'); if (!txt) return;
    if (window.skSizeGate && window.skSizeGate.paint(page)) return; // no size picked for this piece yet (sk-size-gate.js)
    var mv = mainVariant(), xv = state.on ? matchVariant() : null;
    btn.classList.remove('sk-btn-wait'); document.documentElement.classList.remove('sk-need-size');
    if (!mv || !mv.available) { btn.classList.remove('sk-set-btn'); return; }
    if (state.on && !xv) {
      var sp0 = setPricing(mv, refMatch());
      txt.innerHTML = 'Pick ' + matchPiece() + ' size<span class="btn__price" data-product-price>' + setMoney(sp0.price) + '</span>';
      btn.classList.add('sk-set-btn', 'sk-btn-wait'); document.documentElement.classList.add('sk-need-size');
      return;
    }
    if (!xv) {
      var single = (isPre(mv) && window.theme && window.theme.strings && window.theme.strings.preOrder) || (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Add to bag';
      var cmp = mv.compare_at_price && mv.compare_at_price > mv.price ? '<s>' + money(mv.compare_at_price) + '</s>' : '';
      txt.innerHTML = single + '<span class="btn__price" data-product-price>' + money(mv.price) + cmp + '</span>';
      btn.classList.remove('sk-set-btn');
      return;
    }
    var sp = setPricing(mv, xv);
    txt.innerHTML = 'Add set<span class="btn__price" data-product-price>' + setMoney(sp.price) + '</span>';
    btn.classList.add('sk-set-btn');
  }

  function scrollToPanel() {
    var t = state.row && (state.row.querySelector('.sk-mk__sizes') || state.row); if (!t) return;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 140, behavior: 'smooth' });
    state.row.classList.remove('sk-flash'); void state.row.offsetWidth; state.row.classList.add('sk-flash');
  }

  // Add flow: matching piece first (silent), then the theme adds this piece and opens the bag.
  // On window (capture) so it runs before the bag toast's optimistic "Added" listener.
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product__page form[action*="/cart/add"] [data-add-to-cart]');
    if (!btn || state.passThrough || !state.el || !state.on) return;
    if (window.skSizeGate && window.skSizeGate.pending(page)) return; // sk-size-gate.js shows the size row
    var xv = matchVariant();
    if (!xv) { e.preventDefault(); e.stopImmediatePropagation(); scrollToPanel(); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: xv.id, quantity: 1 }] }) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .catch(function () {
        var box = page.querySelector('[data-cart-errors-container]');
        if (box) { box.innerHTML = '<div class="errors">The matching piece could not be added. Adding this piece only.</div>'; setTimeout(function () { box.innerHTML = ''; }, 5000); }
      })
      .then(function () {
        btn.classList.remove('is-loading');
        state.passThrough = true;
        try { btn.click(); } finally { state.passThrough = false; }
      });
  }, true);

  function placeholder() {
    var w = sizeWrapper(); if (!w || page.querySelector('[data-sk-pair-placeholder]')) return;
    if (!pieceOf(currentTitle())) return;
    var ph = document.createElement('div'); ph.className = 'sk-mk sk-mk--ph'; ph.setAttribute('data-sk-pair-placeholder', '');
    w.parentNode.insertBefore(ph, w.nextSibling);
    setTimeout(function () { if (ph.parentNode && !state.el) ph.parentNode.removeChild(ph); }, 6000);
  }

  function run() {
    if (state.el) return;
    var title = currentTitle(), handle = currentHandle();
    if (!pieceOf(title) || !handle) return;
    var optNames = Array.prototype.map.call(page.querySelectorAll('.radio__legend__option-name'), function (n) { return n.textContent.trim().toLowerCase(); });
    if (optNames.filter(function (n) { return /top|bottom/.test(n); }).length > 1) return; // already a set product
    placeholder();
    Promise.all([fetchJson('/products/' + handle + '.js'), findMatch(title, productId(), handle)]).then(function (r) {
      if (!r[0] || !r[1]) { var ph = page.querySelector('[data-sk-pair-placeholder]'); if (ph) ph.parentNode.removeChild(ph); return; }
      state.main = r[0]; state.match = r[1];
      render();
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  window.skSetPair = {
    isOn: function () { return !!(state.el && state.on); },
    hasMatch: function () { return !!(state.el && state.match); },
    waiting: waiting,
    setMode: function (on) { if (state.el) setMode(!!on); },
    mainPiece: function () { var p = state.main ? pieceOf(state.main.title) : 'piece'; return cap(p); },
    matchPiece: matchPiece,
    matchSize: function () { var xv = matchVariant(); return xv ? labelOf(state.match, xv) : null; },
    matchVariantId: function () { return state.matchVariantId; },
    matchVariants: function () { return state.match ? (state.match.variants || []).map(function (v) { return { id: v.id, label: labelOf(state.match, v), available: !!v.available }; }) : []; },
    selectMatch: function (id) { if (!state.match) return; state.matchTouched = true; state.matchVariantId = id; paintMatchSizes(); refreshButton(); document.dispatchEvent(new CustomEvent('sk:set:change', { bubbles: true, detail: { on: state.on } })); },
    singlePrice: function () { var mv = mainVariant(); return mv ? money(mv.price) : ''; },
    offerText: function () { var mv = mainVariant(); if (!mv || !state.match) return ''; var sp = setPricing(mv, refMatch()); return setMoney(sp.each) + ' with set · set total ' + setMoney(sp.price); },
    setPrice: function () { var mv = mainVariant(); if (!mv || !state.match) return ''; return setMoney(setPricing(mv, refMatch()).price); }
  };
})();
